import { Info } from "lucide-react";

export const SimulatedBanner = ({ className = "" }) => (
  <div
    data-testid="simulated-delivery-banner"
    className={`flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900 ${className}`}
  >
    <Info className="mt-0.5 h-4 w-4 shrink-0" />
    <div className="text-sm">
      <span className="font-semibold">Email delivery is simulated.</span>{" "}
      No email provider is connected yet, so update emails are recorded but not actually sent. Investors can still
      read every update in their portal. Add a Resend key to switch on real emails.
    </div>
  </div>
);
